import { InterfaceStatus, PolicyIntegrity } from './scp-policy';

export enum RecoveryStatus {
  Recoverable = 0,
  TempSaving = 1,
  Loaded = 2,
  NotOpen = 3,
}

export interface RecoverablePolicy {
  instanceId: string;
  tempSaveTime: Date;
  recoveryStatus: RecoveryStatus;
  accountId: string | null;
  storageId: string | null;
  insuredName: string | null;
  policyNumber: string | null;
  policyVersion: string | null;
  quoteNumber: string | null;
  quoteVersion: string | null;
  isPolicy: boolean;
  lastModifiedBy: string | null;
  lastModifiedDate: string | null;
  commitDate?: Date | null;
  committedBy?: string | null;
  inceptionDate?: Date | null;
  expirationDate?: Date | null;
  integrity: PolicyIntegrity;
  interfaceStatus: InterfaceStatus;
}

export interface PolicyRecoveryInfo {
  instanceId?: string;
  status: RecoveryStatus;
}

export interface PolicyLockInfo {
  isLocked: boolean;
  lockedBy?: string | null;
  lockedWhen?: Date | null;
}
